export const API_ROOT = `${process.env.VUE_APP_API_BASE_URL}/api/v1/`;
export const API_ROOT_V2 = `${process.env.VUE_APP_API_BASE_URL}/api/v2/`;
export const API_PARTICIPANT_PORTAL = `${process.env.VUE_APP_API_BASE_URL}/api/v3/`;
export const API_ROOT_V3 = `${process.env.VUE_APP_API_BASE_URL}/api/v3/`;
export const API_ROOT_V4 = `${process.env.VUE_APP_API_BASE_URL}/api/v4/`;
export const API_ROOT_ANALYTICS = `${process.env.VUE_APP_API_ANALYTICS_BASE_URL}/api/v1/`;
export const API_PARTICIPANT_WEB_ROOT = `${process.env.VUE_APP_API_PARTICIPANT_WEB_BASE_URL}/api/v1/`;
export const API_ACTIVITY_ROOT = `${process.env.VUE_APP_API_ACTIVITY_BASE_URL}/api/v1/`;
export const API_ACTIVITY_ROOT_V2 = `${process.env.VUE_APP_API_ACTIVITY_BASE_URL}/api/v2/`;
export const API_ROOT_STUDY_RESPONSE = `${process.env.VUE_APP_API_STUDY_RESPONSE_BASE_URL}/api/v1/`;
export const OPENTOK_V2 = `https://api.opentok.com/v2/project/`;
export const API_PARTICIPANT_PORTAL_V4 = `${process.env.VUE_APP_API_BASE_URL}/api/v4/`;
export const SERVERLESS_API_WEB_ROOT = `${process.env.VUE_APP_SERVERLESS_API_BASE_URL}/api/v1/`;
export const COGNITO_API_US_WEB_ROOT = `${process.env.VUE_APP_SERVERLESS_API_BASE_URL}/cognito/api/v1/`;
export const ESIGN_API_WEB_ROOT = `${process.env.VUE_APP_SERVERLESS_API_BASE_URL}/esign/api/v1/`;
export const COGNITO_API_WEB_ROOT = `${process.env.VUE_APP_SERVERLESS_API_BASE_URL}/cognito/api/v1/`;
export const availability = "availability";
export const site = "site";
export const pushnotification = "pushnotification";
export const emailrecipient = "emailrecipient";
export const launch = "launch";
export const multieconsent = "multieconsent";
export const multiConsent = "multi-consent";
export const consents = "consents";
export const add = "add";
export const cohorts = "cohorts";
export const cohort = "cohort";
export const associate = "associate";
export const associates = "associates";
export const details = "details";
export const summary = "summary";
export const keyName = "keyName";
export const removecustomefeilds = "removecustomefeilds";
export const geodemographiccompliance = "geodemographic-compliance";
export const multifeaturesstate = "multi-features-state";
export const studyManagement = "studymanagement/";
export const surveyManagement = "surveymanagement/";
export const participantManagement = "participantmanagement/";
export const responsemanagement = "responsemanagement/";
export const signin = "sign-in";
export const defaultsections = "defaultsections";
export const diseases = "diseases";
export const appicons = "appicons";
export const applogos = "applogos";
export const uploadicon = "uploadicon";
export const uploadlogo = "uploadlogo";
export const studies = "studies";
export const statusKey = "status";
export const validate = "validate";
export const searchstudies = "searchstudies";
export const study = "study";
export const auth = "auth";
export const forgotPassword = "forgot-password";
export const sendOtp = "send-otp";
export const validateOtp = "validate-otp";
export const resetPassword = "reset-password";
export const profile = "profile";
export const platforms = "platforms";
export const icon = "icon";
export const consenticons = "consenticons";
export const icons = "icons";
export const feedbackicons = "feedbackicons";
export const colors = "colors";
export const build = "build";
export const surveys = "surveys";
export const studyActivity = "studyactivity";
export const questions = "questions";
export const users = "users";
export const searchusers = "searchusers";
export const updatepassword = "update-password";
export const participants = "participants";
export const participantProfile = "participantProfilePage";
export const search = "search";
export const updatePassword = "updatePassword";
export const importcsv = "importcsv";
export const importuserscsv = "importuserscsv";
export const exportcsv = "exportcsv";
export const clients = "clients";
export const branding = "branding";
export const onboarding = "onboarding";
export const welcomecontent = "welcomecontent";
export const getpresignedurl = "getpresignedurl";
export const template = "template";
export const verify = "verify";
export const invite = "invite";
export const unsubscribeemail = "unsubscribeemail";
export const consentsections = "consentsections";
export const consent = "consent";
export const consentdocument = "consentdocument";
export const consentprivacy = "consentprivacy";
export const consentlicense = "consentlicense";
export const libraryfeatures = "libraryfeatures";
export const scheduler = "scheduler";
export const participantconfiguration = "participantconfiguration";
export const consentquiz = "consentquiz";
export const overview = "overview";
export const activities = "activities";
export const activity = "activity";
export const survey = "survey";
export const epros = "epros";
export const license = "license";
export const studyepro = "studyepro";
export const eligibilityquestions = "eligibilityquestions";
export const learnmore = "learnmore";
export const sections = "sections";
export const learnmorefeedback = "feedback";
export const downloadPrototype = "download-prototype";
export const prototype = "prototype";
export const templates = "templates";
export const feedback = "send-feedback-email";
export const downloadIrb = "downloadIrb";
export const client = "clients";
export const getclientinfo = "getclientinfo";
export const validic = "validic";
export const devices = "devices";
export const approval = "approval";
export const generateIrb = "generateIrb";
export const onboardedclients = "onboardedclients";
export const clientteam = "clientteam";
export const saveandexit = "saveandexit";
export const appdescription = "appdescription";
export const marketing = "marketing";
export const sortandfilters = "sortandfilters";
export const sortusers = "sortusers";
export const learnmoreicons = "learnmoreicons";
export const pagination = "pagination";
export const sortparticipants = "sortparticipants";
export const featuresState = "features-state";
export const image = "image";
export const video = "video";
export const videos = "videos";
export const mailIrb = "mailIrb";
export const appAvailability = "app-availability";
export const epicintegration = "epicintegration";
export const healthdataaccessconfiguration = "healthdataaccessconfiguration";
export const healthdataaccespoints = "healthdataaccespoints";
export const arrange = "arrange";
export const dataexport = "dataexport";
export const exportKey = "export";
export const dashboards = "dashboards";
export const dashboard = "dashboard";
export const customnotification = "customnotification";
export const refresh = "refresh";
export const truclinic = "truclinic";
export const downloadtemplate = "downloadtemplate";
export const downloadusertemplate = "downloadusertemplate";
export const customlabels = "customlabels";
export const customlabel = "customlabel";
export const queryTool = "responsemanagement/query-tool";
export const documents = "documents";
export const requestsignature = "requestsignature";
export const eventhistory = "eventhistory";
export const piesignature = "piesignature";
export const maildocument = "maildocument";
export const unscheduledAppointment = "unscheduled-appointment";
export const pi = "pi";
export const appointmentCancel = "appointment-cancel";
export const piAppointment = "pi-appointment";
export const truclinicPIEndpoint = "truclinic-pi-endpoint";
export const studyDetails = "study-details";
export const sites = "sites";
export const siteteammembers = "siteteammembers";
export const edc = "edc";
export const formschedules = "formschedules";
export const forms = "forms";
export const schedule = "schedule";
export const formversions = "formversions";
export const participantschedule = "participantschedule";
export const formresponse = "formresponse";
export const unscheduledpackets = "unscheduledpackets";
export const unscheduledpacketresponse = "unscheduledpacketresponse";
export const studyteam = "studyteam";
export const toggledfeatures = "toggledfeatures";
export const openEDCQuery = "edc/queries";
export const openQueries = "edc/openQueries";
export const responses = "responses";
export const events = "events";
export const versions = "versions";
export const dashboardMetrics = "dashboardMetrics";
export const launchStudy = "launch";
export const resendInvite = "resendInvite";
export const associateUser = "associate";
export const disassociateUser = "disassociate";
export const userdefinedParticipantId = "userdefinedid";
export const prepopulation = "prepopulation";
export const notInvited = "notinvited";
export const compliancedata = "compliancedata";
export const multi = "multi";
export const user = "user";
export const specificClient = "client";
export const sftpExport = "sftpexport";
export const execDetails = "execdetail";
export const trigger = "trigger";
export const test = "test";
export const retry = "retry";
export const displayOrder = "displayorder";
export const validicDevices = "validicdevices";
export const types = "types";
export const languages = "languages";
export const applanga = "applanga";
export const telehealth = "telehealthnew";
export const visits = "visits";
export const telehealth2 = "telehealth";
export const appointment = "appointment";
export const startvideocall = "startvideocall";
export const rejectVideoCall = "rejectvideocall";
export const updatecallstarttime = "update-call-starttime";
export const scheduledAppointment = "scheduled-appointment";
export const setting = "setting";
export const siteAppointments = "siteAppointments";
export const signout = "sign-out";
export const exportStudyData = "export-study-data";
export const resetPasswordContent = "resetPasswordContent";
export const sourceDocuments = "sourceDocuments";
export const preSignedUpload = "presignedUpload";
export const preSignedDownload = "presignedDownload";
// export const countries = 'countries';
// export const country = 'country';
export const siteteamemailflag = "siteteamemailflag";
export const countries = "countries";
export const country = "country";
export const participantmilestone = "participantmilestone";
export const participantedcschedule = "participantedcschedule";
export const recurring = "recurring";
export const recurringConfiguration = "recurringConfiguration";
export const exportSurveyFile = "export";
export const importSurveyFile = "import";
export const templateImage = "templateimage";
export const templatelogos = "templatelogos";
export const uploadTemplate = "uploadtemplate";
export const countrySpecificStudyFeatures = "countrySpecificStudyFeatures";
export const reporteddata = "reporteddata";
export const participant = "participant";
export const getstudylanguages = "getstudylanguages";
export const participantedcunschedule = "participantedcunschedule";
export const validateParticipantData = "validateParticipantData";

export const participantweb = "web";
export const homepage = "homepage";
export const bodysection = "bodysection";
export const calloutimage = "calloutimage";
export const setCalloutImage = "setCalloutImage";
export const featureimage = "featureimage";
export const globalelements = "globalelements";
export const sponsorlogo = "sponsorlogo";
export const studylogo = "studylogo";
export const faviconIconLogo = "faviconlogo";
export const agreement = "agreement";
export const eligibility = "eligibility";
export const question = "question";
export const registrationform = "registrationform";
export const registration = "registration";
export const studysite = "studysite";
export const participantWeb = "participant-web/";
export const publishsettings = "publishsettings";
export const eligibilityAnswers = "/eligibilityAnswers";
export const updateStatus = "update-status";
export const publishurl = "publishurl";
export const statusCount = "statusCount";
export const version = "version";
export const contactDetails = "contact-details";
export const slots = "slots";
export const pId = "pId";
export const taskId = "taskId";
export const taskInstanceId = "taskInstanceId";
export const offset = "offset";

export const resendVerify = "resend-verify";
export const blinded = "blinded";
export const disclaimer = "disclaimer";
export const disclaimerUpdate = "disclaimerUpdate";
export const participantdayone = "participantdayone";
export const participantsday = "participantsday";
export const archivestart = "archivestart";
export const start = "start";
export const milestone = "milestone";
export const tasks = "tasks";
export const team = "team";
export const milestones = "milestones";
export const completed = "completed";
export const document = "document";
export const download = "download";
export const analytics = "analytics";
export const enrollment = "enrollment";
export const enrollmentParticipant = "enrollmentparticipant";
export const econsent = "econsent";
export const recruitment = "recruitment";
export const participantStatus = "participant/status";
export const withdraw = "participant/withdrawal";
export const dataCollection = "data-collection";
export const dataPoints = "data-points";
export const publishstatus = "publishstatus";
export const notifications = "notifications";
export const notification = "notification";
export const send = "send";
export const sent = "sent";
export const participantlist = "participantlist";
export const visualization = "vis";
export const activityList = "activityList";
export const studyNotificationSetting = "studyNotificationSetting";
export const publish = "publish";
export const revision = "/revision/";
export const approve = "/approve";
export const unapprove = "/unapprove";
export const locked = "/locked";
export const unlocked = "/unlocked";
export const review = "/review";
export const unreview = "/unreview";
export const history = "/history";
export const detail = "/detail";
export const query = "/query";
export const openQuery = "/openQuery";
export const replies = "/replies";
export const queryStatus = "/query-status";
export const sourcedocument = "/sourcedocument";
export const studyResponse = "study-response/";
export const screenFailure = "screen-failure";

//ACTIVITY-LIBRARY-AND-CONFIGURATOR
export const tags = "tags";
export const therapeuticareas = "therapeuticareas";
export const createdby = "createdby";
export const views = "views";
export const config = "config";
export const pin = "pin";
export const unpin = "unpin";
export const status = "status";
export const group = "group";
export const exportTag = "export";
export const generateSource = "/generateSource";
export const archive = "archive";
export const stop = "stop";
export const preview = "preview";
export const markread = "markread";
export const userPortalNotifications = "userPortalNotifications";
export const archivestop = "archivestop";
export const archivingdetails = "archivingdetails";
export const downloadtelehealthrecord = "downloadtelehealthrecord";
export const login = "login";
export const recordingUrl = "recordingURL";
export const unReadCount = "unReadCount";
export const progress = "progress";
export const tasksAndNotifications = "tasksandcustomnotifications";
export const taskNotificationDisable = "tasknnotificationdisable";
export const applangaCredentials = "/applangacredentials";
export const packet = "packet";
export const signoff = "/signoff";
export const unsignoff = "/unsignoff";
export const configure = "configure";
export const flag = "flag";
export const transfer = "transfer";
export const remove = "remove";

export const demand = "demand";
export const recordVideo = "recordvideocall-details";
export const predinedTasksAndCustomNotifications = "predefined-disable-tasksandcustomnotifications";
export const deactivate = "deactivate";
export const siteteamusers = "siteteamusers";
export const quiz = "quiz";
export const overall = "overall";
export const queries = "queries";
export const formStatus = "form-status";
export const queriesTime = "queries-time";
export const completion = "completion";
export const completionParticipant = "completion-participant";
export const prescreened = "prescreened";
export const languageId = "languageId";
export const participantVideos = "participantVideos";
export const configuration = "configuration";
export const filters = "filters";
export const retention = "retention";
export const retentionRate = "retention-rate";
export const eDRO = "edro";
export const recentData = "recentdata";
export const expectedData = "expected-data";
export const dailySpirometerReading = "dailyreadings";
export const dynamicActivitylist = "activitylist";
export const dynamic = "/dynamic";
export const associated = "/associated";
export const active = "/active";
export const device = "device";
export const webapp = "webapp";
export const duplicate = "/duplicate";

// RESOURCES LIST
export const resourceId = "resourceId";
export const resource = "resource";
export const createresource = "createresource";
export const sitesUrl = "/sites";
export const getallresource = "getallresource";
export const missing = "missing";
export const compliance = "compliance";
export const complianceDetails = "compliance-details";
export const studyCompliance = "study-compliance";
export const complianceInsight = "compliance-insight";
export const score = "score";
export const nonCompilantActivities = "non-compliant-activities";
export const studyEngagement = "engagement";
export const engagementDetails = "platform-insight";
export const totalQuery = "total-query";
export const totalDataChange = "total-data-change";

export const instance = "instance";
export const studyVersion = "studyversion";
export const linkedLanguages = "linkedLanguages";
export const linkedCountries = "linkedCountries";
export const participantsPortalLogin = "signin";
export const schedules = "schedules";
export const checkschedules = "checkschedules";
export const participantTaskSchedules = "participantTaskSchedules";
export const participantTaskNotifications = "participantTaskNotifications";
export const participantCustomNotifications = "participantCustomNotifications";
export const webbitriseurl = "webbitriseurl";
export const mobilejson = "mobilejson";
export const language = "language";
export const applangaTranslated = "applangatranslated";
export const changepassword = "changepassword";
export const smstoggle = "smstoggle";
export const adherence = "adherence";
export const tasksAdherence = "tasksadherence";
export const withdrawstudy = "withdrawstudy";
export const token = "token";
export const studyappmetadata = "studyappmetadata";
export const taskSchedules = "taskschedules";
export const forgotParticipantPassword = "forgotpassword";
export const scheduleDay = "scheduleDay";

export const patientAnalytics = "patient-analytics";
export const insight = "insight";
export const asyncInsight = "asyncInsight";
export const getPatientAnalyticsData = "getPatientAnalyticsData";
export const translate = "translate";
export const participantportalsignout = "signout";
export const paprticipantLanguageStatic = "static";
export const clearNotifications = "clearnotifications";
export const telehealthVisitsDuration = "telehealth-visits-duration";
export const telehealthVisitsCancelled = "telehealth-visits-cancelled";
export const globalsitesettings = "globalsitesettings";
export const updateEmail = "updateemail";
export const emailVerificationStatus = "emailverificationstatus";
export const username = "username";
export const webRegister = "web-register";
export const activate = "activate";
export const signup = "signup";
export const eula = "eula";
export const general = "general";
export const email = "email";
export const changeEmail = "change-email";
export const contact = "contact";
export const appointmentStatus = "appointment-status";
export const appointmentReschedule = "appointment-reschedule";
export const mobiledocuments = "mobiledocuments";
export const address = "address";
export const configured = "configured";
export const updateemail = "updateemail";
export const videocallDetails = "videocall-details";
export const phone = "phone";
export const resend = "resend";
export const requestDeleteAccount = "request-delete-account";

export const benchMarkStatus = "benchMarkStatus";
export const activitywithsteps = "activitywithsteps";
export const pemfile = "pemfile";
export const upload = "upload";
export const type = "type";
export const statusList = "statusList";
export const checkLegacy = "checkLegacy";
export const reasonList = "reasonList";
export const studyId = "studyId";
export const approvedlanguages = "approvedlanguages";
/** Cognito Keys */
export const checkUsername = "check-username";
export const register = "register";
export const generatejwttoken = "generatejwttoken";
export const forgotUsername = "forgot-username";
export const createUsername = "create-username";
export const otp = "otp";
export const editEmail = "edit-email";
export const verifyOtp = "verify-otp";
export const attemptleft = "attempt-left";
export const create = "create";
export const code = "code";
export const pool = "pool";
export const eConsentUplodedData = "eConsentUplodedData";
export const info = "info";
export const confirm = "confirm";
export const verification = "verification";
export const check = "check";
export const method = "method";
export const updateCognitoPhoneNumber = "updateCognitoPhoneNumber";
export const topReasonsForScreenFailures = "topreasonsforscreenfailures";
export const participantstudy = "participant-study-progression";
export const feature = "feature";
export const moveActivityToThreadLibrary = "moveActivityToThreadLibrary";
export const migration = "migration";
export const discontinuationactivity = "discontinuation-activity";
export const otherdiscontinuationreasons = "other-discontinuation-reasons";
/** Cognito Keys End here */

// Start: Analytics KPI 47/48
export const complianceRateOverTime = "get-compliance-change-score";
// End: Analytics KPI 47/48
export const nonComplianceParticipantRetentionrate = "noncompliance-participant-retentionrate";

// Start: Analytics KPI 65
export const sensorCompliance = "sensor-compliance";
// End: Analytics KPI 65
export const orderStatus = "order-status";
export const twofa = "twofa";
export const twofaOtp = "twofa-otp";
export const visitsmetadata = "visitsmetadata";
export const renewSingleUseToken = "renewSingleUseToken";
export const mediaId = "mediaId";
export const datavant = "datavant";
export const tokens = "tokens";
export const toggle = "toggle";
export const datavantconfig = "datavantconfig";
export const datavantConsent = "datavantConsent";
export const consentType = "consentType";
export const grouptags = 'grouptags';
export const variable = "variable";
export const variables = "variables";
export const evaluate_variable = "evaluate_variable";
export const variablebyfilter = "variablebyfilter";
export const activityRevisionId = "activityrevisionid";
export const sso = "sso";
export const regions = "regions";
export const provider = "provider";
export const providers = "providers";
export const settings = "settings";
export const list = "list";
export const metaInfo = "meta-info";
export const meta = "meta";
export const uploadidpmeta = "upload-idp-meta";
